import React, { useEffect, useState } from 'react'
import { firestore } from '../../../firebase'

function TeamsSelector({teamId, setTeamId, teamName, setTeamName, setTeamLogo}) {

    const [teams, setTeams] = useState([])

    useEffect(() => {

        try {
            const teamsRef = firestore.collection("teams");
            teamsRef.orderBy("team_name").onSnapshot(({docs}) => {
                const teams = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                })
                setTeams(teams)
            })
        } catch (error) {
            
        }

    }, [])

    function teamChangeHandler(e) {

        const filteredTeams = teams.filter(team => {
            return team.id === e.target.value;
        })

        setTeamId(e.target.value)
        if (filteredTeams) {
            setTeamName(filteredTeams[0].team_name)
            if (setTeamLogo) {
                setTeamLogo(filteredTeams[0].team_logo)
            }
            
        } else {
            setTeamName("")
        }
        
    }

    return (
        <div>
            <select onChange={teamChangeHandler} className="browser-default custom-select">
                <option>Velg lag</option>
                {teams && teams.map((team, index) => {
                    return (
                        <option key={index} value={team.id}>{team.team_name}</option>
                    )
                })}
            </select>
        </div>
    )
}
export default TeamsSelector